export interface HiloDocument {
    max: number;
}